var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2 rounded-full",class:{
        'text-green-700 bg-green-200': _vm.iconType === 'success',
        'text-red-700 bg-red-100': _vm.iconType === 'fail',
        'text-blue-700 bg-blue-200': _vm.iconType === 'neutral',
    }},[_c('Icon',{class:_vm.dropdown ? 'w-4 h-4' : 'w-6 h-6',attrs:{"icon":"solar:lightbulb-broken"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }